<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/axyZwp/tc-custom/9781398456471.jpg?1705687958509" alt="This image is the cover for the book A Bare Chronicle of Existence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Bare Chronicle of Existence
      </h1>
      <p class="bookDescription body article font2">
        <p>On the very same day as his brother, Arnold enrolled to serve in WW1. He signed up for the Royal Naval Volunteer Reserves and in April 1915 set sail on HMS India. A few short months later, he found himself floating in the North Sea. This is his story and the story of the men who found themselves interned in Norway for the remainder of the war. It is a story of loneliness and love. Of conflict and of isolation. It is a story from WW1 that is rarely told but one that deserves to be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca Clarke
      </h2>
      
      <p class="authorDescription body article">Rebecca was born in Australia and now lives in London with her husband and dogs and any combination of her three children (depending on who has decided to move in this week.)  Rebecca spends her non-writing time singing, sailing, swimming or walking the dogs.The rest of the time is spent sorting the family archives finding more inspiration for stories about every day, interesting people.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dfb41740